import dayjs from 'dayjs';

export default () => ({
  lastActionDt: dayjs().toISOString(),
});
